module.exports = __webpack_public_path__ + "static/lacoste-b490f3d58b1445d90ab587293aa50e6d.svg";